/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ConversationThreadContainerLocal = {
    readonly refreshStream: boolean | null;
    readonly " $refType": "ConversationThreadContainerLocal";
};
export type ConversationThreadContainerLocal$data = ConversationThreadContainerLocal;
export type ConversationThreadContainerLocal$key = {
    readonly " $data"?: ConversationThreadContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"ConversationThreadContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationThreadContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshStream",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '5f62936cddc1141b442f21b9f8d4f6e2';
export default node;
